module.exports = __webpack_public_path__ + "resources/symbols-c5900671240b40432e166c075b4d325e.svg";